import { Heading } from '@components/rolex-ui/Heading'
import { Text } from '@components/rolex-ui/Text'
import { RolexRichText } from '../RichText'
import { FC } from 'react'
import { Item } from '@lib/kontent'
import { RolexSendUsAMessage } from '@lib/kontent/models/RolexSendUsAMessage'
import { useTranslation } from 'next-i18next'
import { SendAMessageDisplayMode } from '@pages/rolex/contact/send-a-message'

type RolexContactFormMessageProps = {
  item: Item<RolexSendUsAMessage>
  displayMode: SendAMessageDisplayMode
}

export const RolexContactFormMessage: FC<RolexContactFormMessageProps> = ({
  item,
  displayMode,
}) => {
  const { t } = useTranslation('other')
  return (
    <div className="flex flex-col text-center">
      <Text variant="body24" className="mb-2 text-rolexBrown">
        {item.elements.pretitle.value}
      </Text>
      <Heading variant="headline50" className="mb-5 text-rolexBrown">
        {displayMode === 'message' && item.elements.send_a_message_title.value}
        {displayMode === 'other-fields' && item.elements.enter_contact_details_title.value}
        {displayMode === 'success' && t('thanks')}
      </Heading>
      {displayMode !== 'success' && (
        <Text variant="fixed16" weight="light" className="mb-4 w-full max-w-[500px] self-center">
          {displayMode === 'message'
            ? item.elements.send_a_message_description.value
            : item.elements.enter_contact_details_description.value}
        </Text>
      )}
      {displayMode === 'success' && <RolexRichText content={item.elements.success_description} />}
    </div>
  )
}
